/**
 * @prop --background-color: Background of footer (lower part)
 * @prop --background-color-menu: Background of footer menu (upper part)
 *
 * @prop --stzh-footer-background-color: **Global**: Background of footer (lower part)
 * @prop --stzh-footer-background-color-menu: **Global**: Background of footer menu (upper part)
 */

stzh-footer {
  --background-color: var(--stzh-footer-background-color, #{$footerBackgroundColor});
  --background-color-menu: var(--stzh-footer-background-color-menu, #{$colorPrimary80});

  @media print {
    display: none;
  }
}

.stzh-footer {
  @include host;
  @include fontSize('micro');
  background-color: var(--background-color);

  --stzh-flyingfocus-color: #{$colorWhite};
  --stzh-base-color: #{$colorWhite70op};
  --stzh-link-color: #{$colorWhite70op};
  --stzh-link-hover-color: #{$colorWhite};
  --stzh-link-text-decoration-line: none;
  --stzh-link-hover-text-decoration-line: none;

  [slot="logo"],
  [slot="logo"] img {
    display: block;
    height: 38px;
  }

  [slot="info"] {
    margin: 0;
  }

  &__wrapper {
    @include container;
    padding: space('xlarge') 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: space('xlarge');

    @include mq($from: medium) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }

  &__menu {
    background-color: var(--background-color-menu);
  }

  &__menu-inner {
    @include container;
    @include fontSize('centi');
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: space('xxlarge') 0;

    --stzh-link-height: 44px;
  }

  &__menu-inner,
  &__logo,
  &__info,
  &__links {
    &:empty {
      display: none;
    }
  }

  &__copyright-wrapper {
    @include fontSize('milli');
    display: flex;
    flex-direction: column;
    gap: space('medium');
    color: $colorWhite;

    @include mq($from: medium) {
      gap: space('large');
      margin-right: auto;
    }
  }

  &__copyright {
    display: flex;
    align-items: center;
    height: 44px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: space('large');
  }

  &__links {
    --stzh-link-height: 44px;

    @include mq($from: medium) {
      margin-left: auto;
    }
  }

  &__links,
  slot-fb[name="link"]:not([hidden]) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @include mq($from: small) {
      flex-direction: row;
      align-items: center;
      gap: space('large');
    }
  }

  /* Logo or info filled variant */

  &--has-logo &__wrapper,
  &--has-info &__wrapper {
    @include mq($from: medium) {
      align-items: flex-start;
    }
  }
}
